import { useTranslator } from '@bluebeam/react-i18n';
import * as React from 'react';
import IconButton from '../IconButton/IconButton';

type SearchInputProps = {
  /** The unique identifier for the search input */
  id: string;

  /** The callback to invoke when input text changes */
  onChange: (newValue: string) => void;

  /** The value of the search input */
  value: string;
};

const SearchInput: React.VFC<SearchInputProps> = ({ onChange, value }) => {
  const { translate } = useTranslator(['mapView']);
  return (
    <div
      css={{
        alignItems: 'center',
        border: '0.5px solid #D1D5DE',
        borderRadius: '8px',
        display: 'flex',
        flexDirection: 'row',
        height: '2rem',
        justifyContent: 'space-between',
        '@media(hover: hover)': {
          '&:not(:hover) button': {
            display: 'none',
          },
        },
      }}
    >
      <div
        css={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 1,
          height: '32px',
          width: '32px',
        }}
      >
        <svg
          css={{ margin: '8px' }}
          fill="#4B585D"
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
        >
          <path d="M7,2 C9.76142375,2 12,4.23857625 12,7 C12,8.2455035 11.5445972,9.38464198 10.7912205,10.2599866 L13.8902016,13.3598715 C14.036628,13.5063383 14.0365953,13.7437751 13.8901285,13.8902016 C13.7474173,14.0328735 13.5183413,14.0365007 13.3712384,13.9011064 L13.3597984,13.8901285 L10.2609296,10.7904087 C9.3854602,11.54427 8.24595082,12 7,12 C4.23857625,12 2,9.76142375 2,7 C2,4.23857625 4.23857625,2 7,2 Z M7,2.75 C4.65278981,2.75 2.75,4.65278981 2.75,7 C2.75,9.34721019 4.65278981,11.25 7,11.25 C9.34721019,11.25 11.25,9.34721019 11.25,7 C11.25,4.65278981 9.34721019,2.75 7,2.75 Z" />
        </svg>
        <input
          css={{
            border: 'none',
            outline: 'none',
            background: 'none',
            color: '#4B575D',
            width: '100%',
          }}
          onChange={(event) => {
            onChange(event.target.value);
          }}
          value={value}
          placeholder={translate('mapView:searchInput.search')}
        />
      </div>
      <div
        css={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {Boolean(value) && (
          <IconButton
            variant="icon-only"
            aria="clear-search"
            size="small"
            css={{ marginRight: '10px' }}
            onClick={() => onChange('')}
          >
            <svg viewBox="0 0 24 24" fill="#4B585D">
              <path d="M12,4 C16.418278,4 20,7.581722 20,12 C20,16.418278 16.418278,20 12,20 C7.581722,20 4,16.418278 4,12 C4,7.581722 7.581722,4 12,4 Z M8.74730881,7.89878067 C8.51299423,7.66446609 8.13309524,7.66446609 7.89878067,7.89878067 C7.67047416,8.12708718 7.66462015,8.49360795 7.88121863,8.72900237 L7.89878067,8.74730881 L11.1515426,11.9999293 L7.89878067,15.2526912 C7.66446609,15.4870058 7.66446609,15.8669048 7.89878067,16.1012193 C8.12708718,16.3295258 8.49360795,16.3353799 8.72900237,16.1187814 L8.74730881,16.1012193 L12,12.8485281 L15.2526912,16.1012193 C15.4870058,16.3355339 15.8669048,16.3355339 16.1012193,16.1012193 C16.3295258,15.8729128 16.3353799,15.5063921 16.1187814,15.2709976 L16.1012193,15.2526912 L12.8485281,12 L16.1012193,8.74730881 C16.3355339,8.51299423 16.3355339,8.13309524 16.1012193,7.89878067 C15.8729128,7.67047416 15.5063921,7.66462015 15.2709976,7.88121863 L15.2526912,7.89878067 L12.0000707,11.1514012 L8.74730881,7.89878067 Z" />
            </svg>
          </IconButton>
        )}
      </div>
    </div>
  );
};

export default SearchInput;
